import {
    SAVE_HOST_DETAILS,
    SAVE_HOST_DETAILS_SUCCESS,
    SAVE_HOST_DETAILS_FAILS
} from './CreateHostActionType';

export const createHostReducer = (
    state = {
    },
    action
) => {
    switch (action.type) {
        case SAVE_HOST_DETAILS:
            return {
                ...state,
                hostDetails: {
                    ...state.hostDetails,
                    fetching: true,
                    error: { status: false, message: '' },
                    success:false
                }
            };

        case SAVE_HOST_DETAILS_SUCCESS:
            return {
                ...state,
                hostDetails: {
                    ...state.hostDetails,
                    fetching: false,
                    error: { status: false, message: '' },
                    success:true
                }
            };

        case SAVE_HOST_DETAILS_FAILS:
            return {
                ...state,
                hostDetails: {
                    ...state.hostDetails,
                    fetching: false,
                    error: { status: true, message: action.payload },
                    success:false
                }
            };

        default:
            return state;
    }
};